import { render, staticRenderFns } from "./ProductInfoPopup.vue?vue&type=template&id=6f16ce03&scoped=true&"
import script from "./ProductInfoPopup.vue?vue&type=script&lang=js&"
export * from "./ProductInfoPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoPopup.vue?vue&type=style&index=0&id=6f16ce03&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f16ce03",
  null
  
)

export default component.exports